<script>
export default {
  components: {},
}
</script>

<template>
  <div class="card-header"><slot>CardHeader.vue</slot></div>
</template>
